import { useState } from 'react';
import { useAlertArrivals, useArrivals } from '@d-orca/shared/client/hooks';
import type { IBellArrivals } from './useArrivalPeek';

interface ISeen {
  chat: number;
  alerts: number;
  arrived: readonly { id: string }[];
}

/**
 * Everything the bell answers an arrival with — chat's and the alerts' as
 * one: the count moves when either does, and what arrived is the latest
 * one's, by the ids of the bell's items (an alert's item is `alert:<id>`).
 */
export function useBellArrivals(siteId: string | null): IBellArrivals {
  const chat = useArrivals(siteId);
  const alerts = useAlertArrivals(siteId);
  const [seen, setSeen] = useState<ISeen>({ chat: chat.count, alerts: alerts.count, arrived: [] });

  // Brought up to date while rendering, so the count and what it brought never disagree for a frame.
  let next = seen;
  if (next.chat !== chat.count) next = { ...next, chat: chat.count, arrived: chat.arrived };
  if (next.alerts !== alerts.count) {
    next = { ...next, alerts: alerts.count, arrived: alerts.arrived.map((a) => ({ id: `alert:${a.id}` })) };
  }
  if (next !== seen) setSeen(next);

  return { count: chat.count + alerts.count, arrived: next.arrived };
}
